import { useDroppable } from '@dnd-kit/core';
import { useRecoilValue } from 'recoil';

import { NEW_PRIMARY_LIGHT, PRIMARY, PRIMARY_LIGHT } from 'constants/colors';

import { dragActionActiveAtom } from '../../atoms';

import { Box } from '@mui/material';

import CustomScrollContainer from '../CustomScrollContainer/CustomScrollContainer';
import { panelThemeColors, PanelTheme } from '../ActivityPanel/constants';
import { DayPart } from 'generated/index';
import { t } from 'i18next';
import { useEffect } from 'react';

interface ToPlanDropzoneProps {
  children?: JSX.Element | JSX.Element[];
  dayPart?: DayPart;
  dropzonePadding?: string;
  handleDrop?: () => void;
}

export default function ToPlanDropzone({
  children,
  dayPart = 'MORNING',
  handleDrop
}: ToPlanDropzoneProps) {
  const { setNodeRef, isOver } = useDroppable({
    id: 'TO_PLAN_DROPZONE',
    data: {
      planningEntityType: '',
      appointmentGroupingEntityId: '',
      planningEntityIdentifier: {
        entityId: ''
      },
      scheduleStart: '',
      isToPlan: true
    }
  });

  const dragActionActive = useRecoilValue(dragActionActiveAtom);
  const { borderColor } = panelThemeColors[dayPart as PanelTheme];

  useEffect(() => {
    if (isOver) {
      handleDrop && handleDrop(); // Trigger handleDrop when task is dropped
    }
  }, [isOver, handleDrop]);

  return (
    <Box
      ref={setNodeRef}
      component="div"
      display="flex"
      position="relative"
      flexShrink={0}
      mx={1}
      sx={{
        overflow: 'hidden',
        flexDirection: 'column',
        boxSizing: 'border-box',
        backgroundColor: isOver ? PRIMARY_LIGHT : NEW_PRIMARY_LIGHT,
        pointerEvents: 'auto',
        transition: 'border-color 0.2s ease-in-out',
        color: '#6b6b6b',
        margin: 0,
        borderLeft: `1px solid ${borderColor}`,
        boxShadow: isOver ? `inset 0px 0px 0px 2px ${PRIMARY}` : `none`
      }}
    >
      <CustomScrollContainer
        sx={{
          overflowY: dragActionActive ? 'hidden' : 'auto',
          scrollbarWidth: 'none',
          display: 'block'
        }}
      >
        <Box display="flex" justifyContent="center">
          {children}
        </Box>
        {isOver && (
          <Box
            position="absolute"
            top={0}
            left={0}
            right={0}
            bottom={0}
            zIndex={99999}
            display="flex"
            justifyContent="center"
            alignItems="center"
            fontSize={24}
            border={`2px dashed ${PRIMARY}`}
            borderRadius={4}
            boxSizing={'border-box'}
            margin={1}
            color={PRIMARY}
          >
            {t(`taskList.dropZone`)}
          </Box>
        )}
      </CustomScrollContainer>
    </Box>
  );
}
